export interface FAQItem {
  question: string;
  answer: string;
}

export const faqList: FAQItem[] = [
  {
    question: "奶水动漫在线需要注册才能观看吗？",
    answer: "不需要！奶水动漫在线完全免费开放，您无需注册或登录即可畅享所有动漫资源。我们致力于为动漫爱好者提供最便捷的观看体验。",
  },
  {
    question: "动漫的画质如何？支持哪些清晰度？",
    answer: "我们提供高清（720P）和超清（1080P）两种画质选择。所有动漫资源均经过精心压制，确保在保证清晰度的同时优化加载速度，让您享受流畅的观影体验。",
  },
  {
    question: "支持手机和平板观看吗？",
    answer: "当然支持！奶水动漫在线采用响应式设计，完美适配电脑、平板和手机等各类设备。无论您使用什么设备，都能获得良好的观看体验。",
  },
  {
    question: "动漫更新频率是怎样的？",
    answer: "我们会与日本同步更新热门连载番剧，通常在播出后24小时内完成中文字幕制作并上架。经典动漫和已完结作品则持续在线，随时可观看。",
  },
  {
    question: "如何找到我想看的动漫？",
    answer: "您可以通过顶部的搜索功能直接搜索动漫名称，也可以通过分类页面按「热血」「恋爱」「搞笑」「奇幻」等类型浏览。首页的推荐和排行榜也能帮您发现好作品。",
  },
  {
    question: "奶水动漫在线的动漫资源是否正版？",
    answer: "我们尊重知识产权，所有动漫资源均来自公开渠道。我们建议用户支持正版，奶水动漫在线仅作为便捷的观看入口，方便动漫爱好者发现和欣赏优秀作品。",
  },
];